import React from 'react';
import { motion } from 'framer-motion';
import { PlugIcon, LayersIcon, ZapIcon } from 'lucide-react';
const steps = [{
  n: '01',
  icon: PlugIcon,
  title: 'Connect your sources',
  body: 'OAuth into HubSpot, GA4, Google Ads, Meta, Salesforce and more. No pipelines to build, no engineers required.'
}, {
  n: '02',
  icon: LayersIcon,
  title: 'Unify every signal',
  body: 'We resolve identities, dedupe events and map fields automatically — one clean schema across all your tools.'
}, {
  n: '03',
  icon: ZapIcon,
  title: 'Act in real time',
  body: 'Dashboards, alerts and syncs fire the instant a signal lands. Route intent to sales, spend to finance, wins to Slack.'
}];
export function HowItWorks() {
  return <section id="how-it-works" className="py-20 md:py-28" data-id="element-82">
      <div className="mx-auto max-w-[1200px] px-5 md:px-8" data-id="element-83">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end" data-id="element-84">
          <h2 className="max-w-xl font-display text-4xl font-semibold leading-[1.05] tracking-tight md:text-6xl" data-id="element-85">
            From scattered to unified in three moves.
          </h2>
          <p className="max-w-sm text-ink/60" data-id="element-86">
            Most teams are live in under an hour. No warehouse, no data team, no
            duct-taped Zapier flows.
          </p>
        </div>

        <div className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-ink/15 bg-ink/15 md:grid-cols-3" data-id="element-87">
          {steps.map((s, i) => <motion.div key={s.n} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.12
        }} className="flex flex-col bg-cream p-8 md:p-10" data-id="element-88">
              <div className="flex items-center justify-between" data-id="element-89">
                <span className="font-display text-5xl font-semibold text-ink/15" data-id="element-90">
                  {s.n}
                </span>
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-signal text-white" data-id="element-91">
                  <s.icon className="h-5 w-5" data-id="element-92" />
                </div>
              </div>
              <h3 className="mt-10 text-2xl font-semibold" data-id="element-93">{s.title}</h3>
              <p className="mt-3 text-ink/60" data-id="element-94">{s.body}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}